import { ref } from 'vue';

export const enum Period {
  Latest = 1,
  OneDay = 2,
  TwoDay = 3,
  FiveDay = 6,
  OneMonth = 22,
  TwoMonth = 43,
  ThreeMonth = 64,
  SixMonth = 126,
  NineMonth = 189,
  OneYear = 252
}

export const PERIOD_MAP = {
  'latest': Period.Latest,
  'oneday': Period.OneDay,
  'twoday': Period.TwoDay,
  'fiveday': Period.FiveDay,
  'onemonth': Period.OneMonth,
  'twomonth': Period.TwoMonth,
  'threemonth': Period.ThreeMonth,
  'sixmonth': Period.SixMonth,
  'ninemonth': Period.NineMonth,
  'oneyear': Period.OneYear,
} as const;

type PeriodKey = keyof typeof PERIOD_MAP | 'yeartodate';

function isValidPeriod(value: string): value is PeriodKey {
  return value === 'yeartodate' || Object.keys(PERIOD_MAP).includes(value);
}

const DEFAULT_PERIOD: PeriodKey = 'oneday';

// Factory for creating instance-scoped period state
export function createPeriod(options?: { period?: PeriodKey }) {
  const periodKey = ref<PeriodKey>(options?.period ?? DEFAULT_PERIOD);
  return { periodKey };
}

export type { PeriodKey };

export {
  DEFAULT_PERIOD,
  isValidPeriod
};
